// Random int
export function getRandomIntInclusive(min, max) {
  const roundedMin = Math.ceil(min);
  const roundedMax = Math.floor(max);
  // Both the maximum and the minimum is inclusive
  return Math.floor(Math.random() * (roundedMax - roundedMin + 1)) + min;
}

// Shuffle array (Durstenfeld shuffle)
export function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

// Luminance
function hexToRgb(hex) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
      red: parseInt(result[1], 16),
      green: parseInt(result[2], 16),
      blue: parseInt(result[3], 16),
    }
    : null;
}

function colorLuminance({ red, green, blue }) {
  return (0.299 * red + 0.587 * green + 0.114 * blue) / 256;
}

export function getAppropriateColor(hexColor) {
  return colorLuminance(hexToRgb(hexColor)) > 0.7
    ? 'rgba(0,0,0, .8)'
    : 'rgba(255,255,255, .9)';
}



// WEBPACK FOOTER //
// ./helpers.js